import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { auth } from "../../components/auth/firebase/firebase";
import { signInWithEmailLink, isSignInWithEmailLink } from "firebase/auth";
import { LoadingSpinner } from "../../components/ui";

// Dashboard page - handles magic link authentication then redirects to home
const siteMetadata = {
  title: "Designing Multi-Agent Systems",
  description: "Access your book downloads, manage your account, and explore exclusive content for Designing Multi-Agent Systems",
  author: "Victor Dibia",
  image: "/images/og-service.png",
  keywords: "multi-agent, customer platform, dashboard, payments",
  twitterUsername: "@designingwithml"
};

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = React.useState(true);
  const [message, setMessage] = React.useState("Checking authentication...");

  React.useEffect(() => {
    const handleMagicLinkAndRedirect = async () => {
      try {
        // Check if this is a magic link sign-in
        if (auth && isSignInWithEmailLink(auth, window.location.href)) {
          setMessage("Processing magic link...");

          let email = window.localStorage.getItem("emailForSignIn");

          // If no stored email, prompt user (this can happen if they open link on different device)
          if (!email) {
            email = window.prompt("Please provide your email for confirmation");
          }

          if (email) {
            try {
              // Sign in with the magic link
              await signInWithEmailLink(auth, email, window.location.href);
              window.localStorage.removeItem("emailForSignIn");
              setMessage("Sign in successful! Redirecting...");

              // Wait a moment for auth state to propagate
              setTimeout(() => {
                navigate("/");
              }, 500);
            } catch (error: any) {
              console.error("Magic link sign-in error:", error);
              setMessage("Sign in failed. Redirecting...");
              setTimeout(() => {
                navigate("/");
              }, 2000);
            }
          } else {
            // No email provided
            navigate("/");
          }
        } else {
          // Not a magic link, just redirect
          setMessage("Redirecting to dashboard...");
          setTimeout(() => {
            navigate("/");
          }, 100);
        }
      } catch (error) {
        console.error("Dashboard redirect error:", error);
        navigate("/");
      }
    };

    handleMagicLinkAndRedirect();
  }, [navigate]);

  return (
    <Layout meta={siteMetadata} title="Dashboard" link="/dashboard">
      <main className="container mx-auto px-4 py-8">
        <div className="flex flex-col items-center justify-center min-h-[400px]">
          <LoadingSpinner size="lg" />
          <p className="text-secondary mt-4">{message}</p>
        </div>
      </main>
    </Layout>
  );
};


export default DashboardPage;
